// Copyright (c) 2020 WiseTime. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ListUserCuesResponse, UserCue } from "../../generated/wisetime/user/cues/v4/user_cues_pb"
import { RootState } from "../../app/store"

export type UserCuesState = {
  userCuesList: UserCue.AsObject[],
}

export const initialState: UserCuesState = {
  userCuesList: [],
}

export const slice = createSlice({
  name: "user-cues",
  initialState,
  reducers: {
    setUserCuesList: (state, action: PayloadAction<ListUserCuesResponse.AsObject>): void => {
      state.userCuesList = action.payload.userCuesList
    },
    createUserCue: (state, action: PayloadAction<UserCue.AsObject>): void => {
      state.userCuesList.push(action.payload)
    },
  },
})

export const {
  setUserCuesList,
  createUserCue,
} = slice.actions

export const selectUserCues = (state: RootState): UserCue.AsObject[] => state.userCues.userCuesList

export default slice.reducer
